import {Form, Row, TabsProps} from "antd";
import {Tabs} from "components/common";
import {InputFields} from "components/common";
import TableCustom from "components/common/TableCustom/TableCustom";
import React, {useEffect} from "react";
import {fields} from "./config";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import {setButtonsHeader, setSiderKey} from "redux/reducer/common";
import {tabKeys} from "types/enums";
import ListProposePay from "./List/ListProposePay";
import DetailProposePay from "./Detail/DetailProposePay";
const ProposePay = props => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(setButtonsHeader([]));
    dispatch(setSiderKey("quanLyThanhToan"));
  }, []);
  const activeTab = useAppSelector(state => state.common.activeTab);
  const items: TabsProps["items"] = [
    {
      key: tabKeys.PROPOSE_PAY.LIST,
      label: `Danh sách đề nghị thanh toán`,
      children: <ListProposePay />,
    },
    {
      key: tabKeys.PROPOSE_PAY.DETAIL,
      label: `Chi tiết đề nghị thanh toán`,
      children: <DetailProposePay />,
    },
  ];
  return (
    <div className="page">
      <div className="main">
        <Tabs activeKey={activeTab} items={items} />
      </div>
    </div>
  );
};
export default ProposePay;
